import { allTrackers } from "app/services/track/track";
import type { track as TrackType } from "pro-features/components/WithTrack/src/context";

type SuperAgentSidebarButtonTracking = {
    trackClickSidebarButton: () => void;
};

const createSuperAgentSidebarButtonTracking = (track: TrackType): SuperAgentSidebarButtonTracking => ({
    trackClickSidebarButton: () => {
        track("SI navigation bar", "click", "Super agent");
    },
});

export default createSuperAgentSidebarButtonTracking(allTrackers.dispatchTrackEvent.bind(allTrackers));
